import { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Modal, Row, FormFeedback } from "reactstrap";
import { campaignValidationSchema } from '../../../../constants/Schemas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import InputField from '../../../../components/InputField';
import { Actions } from '../../../../redux/actions';
import { dispatch } from '../../../../utils/store';
import { TEMPLATES_API } from '../../../../constants/Configs';
import { templatesListDTO } from '../../utils/dtos/templates';
import { removeEmptyKeysFromObject, setSelectedDropdownForSameValue, trimObjectValues, uploadImage } from '../../../../services/middleware';
import { handleError } from '../../../../utils/toast';
import { API_REQUEST, CAMPAIGN_FILE_TYPE, ImageLinks, ImageType, selectDropdownStyle, TemplateButtonsDropdown, multiSelectDropdownStyle, TemplateButtonsOptions, TemplateButtonsOptionsRSVP, CountryCodeDropdownOptions, CountryCode } from '../../../../constants/General';
import { useSelector } from 'react-redux';
import { getCustomers } from '../../utils/middleware/marketings';
import { getEvent } from '../../utils/middleware/events'
import "./campaign.css"
import moment from 'moment-timezone';
import API from "../../../../services/api"
import { GET_AICONTENT } from "../../../../constants/Configs"
import MobileViewCampaign from '../MobileViewCampaign';
import { addQuickTemplate } from '../../utils/middleware/templates';

const getThirdWord = (text) => {
  const words = text.trim().split(/\s+/);
  return words.length >= 3 ? words[2] : null;
};

const replaceThirdWordWithPlaceholder = (text) => {
  const words = text.trim().split(/\s+/);
  if (words.length >= 3) {
    words[2] = '{{1}}';
    return words.join(' ');
  }
  return text;
};

export default function CampaignModal(props) {
  // Props

  const { open, campaign, handleCloseModal, handleSuccess } = props

  // Store
  const [buttonActions, setButtonActions] = useState(!!campaign?.buttons?.length ? 'action' : '');
  const { tags, customers } = useSelector(state => state.restaurantAdminMarketings)
  const { search, activeSort, sortOrder, totalCount, page } = useSelector(state => state.restaurantAdminTickets)
  const { eventList } = useSelector(state => state.restaurantAdminEvents)
  const [buttonText, setButtonText] = useState('Generate campaign content through AI');
  const { pageSize } = useSelector(state => state.user)
  //State
  const [templates, setTemplates] = useState([])
  const [buttonActionsOptions, setButtonActionsOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null)
  const [isRSVPChecked, setIsRSVPChecked] = useState(false);
  const [selectedButtons, setSelectedButtons] = useState(!!campaign?.buttons?.length
    ? campaign.buttons.reduce((acc, item, index) => {
      acc[index] = item.type;
      return acc;
    }, {})
    : {
      0: ''
    });

  // Mount
  useEffect(() => {
    getEvent({ search, sortBy: activeSort, orderBy: sortOrder, page, isRsvp: true })
    let pageCount = Math.ceil(totalCount / pageSize)
    if (totalCount && page > pageCount) {
      dispatch(Actions.RestaurantAdminReservations.SetPage, pageCount)
    }
  }, [search, activeSort, sortOrder, totalCount, page, pageSize])

  useEffect(() => {
    setButtonActionsOptions(buttonActions == 'rsvp_action' ? TemplateButtonsOptionsRSVP : TemplateButtonsOptions)
  }, [buttonActions])

  useEffect(() => {
    const buttons = Object.values(selectedButtons).filter((item) => !!item).map((item) => item);
    formik.setFieldValue("buttons", buttons);
  }, [selectedButtons])

  // Use useCallback to memoize the debounced function
  const debouncedGetCustomers = useCallback(
    debounce((inputValue) => {
      if (inputValue) {
        getCustomers(inputValue);
      }
    }, 500), // Adjust the debounce delay as needed
    []
  );

  const handleInputChange = (inputValue) => {
    debouncedGetCustomers(inputValue);
  };
  const handleRSVPChange = (e) => {
    setIsRSVPChecked(e.target.checked);
  };

  const updateDropdownOption = (data) => {
    const newOptions = TemplateButtonsOptions.map(option => {
      return {
        ...option,
        disabled: !!Object.values(data).find(item => item === option.value)
      }
    })
    setButtonActionsOptions(newOptions);
  }

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (checked) {
      formik.setFieldValue('occuranceDay', [...formik.values.occuranceDay, name]);
    } else {
      let days = formik.values.occuranceDay;
      if (typeof formik.values.occuranceDay === 'string') {
        days = days.split(',')
      }
      formik.setFieldValue('occuranceDay', days.filter(day => day !== name));
    }
  };

  const actionButtonOption = (item, action) => {
    return action === 'PHONE_NUMBER' ? <>
      <Col md={3}>
        <Input
          type="text"
          placeholder="Enter button label"
          value={formik.values.PHONE_NUMBER.text}
          disabled={
            formik.values.buttons.indexOf("PHONE_NUMBER") ===
            -1
          }
          onChange={(e) =>
            formik.setFieldValue("PHONE_NUMBER", {
              ...formik.values.PHONE_NUMBER,
              text: e.target.value,
            })
          }
          invalid={formik.errors.PHONE_NUMBER?.text}
        />
        <FormFeedback>
          {formik.errors?.PHONE_NUMBER?.text}
        </FormFeedback>
        <span className='input-charactor-count-template'>{formik.values?.PHONE_NUMBER?.text.length || 0}/25</span>
      </Col>
      <Col md={6} className="pl-0">
        <div className="d-flex">
          <section className="mb-2 input-group-alternative country-code">
            <Select
              isDisabled={
                formik.values.buttons.indexOf(
                  "PHONE_NUMBER"
                ) === -1
              }
              className="custom-select"
              options={CountryCodeDropdownOptions}
              value={formik.values.countryCode}
              isSearchable={false}
              styles={selectDropdownStyle}
              onChange={(selectedOption) => {
                formik.setFieldValue(
                  "countryCode",
                  selectedOption
                );
              }}
            />
            {formik.touched?.countryCode &&
              formik.errors.countryCode && (
                <span className="error-message input-group-alternative">
                  {formik.errors.countryCode}
                </span>
              )}
          </section>
          <div className="full-width relative">
            <Input
              type="text"
              placeholder="Enter number"
              value={formik.values.PHONE_NUMBER.phone_number}
              disabled={
                formik.values.buttons.indexOf(
                  "PHONE_NUMBER"
                ) === -1
              }
              onChange={(e) =>
                formik.setFieldValue("PHONE_NUMBER", {
                  ...formik.values.PHONE_NUMBER,
                  phone_number: e.target.value,
                })
              }
              invalid={
                formik.errors.PHONE_NUMBER?.phone_number
              }
            />
            <FormFeedback>
              {formik.errors?.PHONE_NUMBER?.phone_number}
            </FormFeedback>
            <span className='input-charactor-count'>{formik.values?.PHONE_NUMBER?.phone_number.length || 0}/11</span>
          </div>
          {removeActionButton(item)}
        </div>
      </Col>
    </> : action === 'URL' ? <>
      <Col md={4}>
        <Input
          type="text"
          placeholder="Enter button label"
          value={formik.values.URL.text}
          disabled={
            formik.values.buttons.indexOf("URL") === -1
          }
          onChange={(e) =>
            formik.setFieldValue("URL", {
              ...formik.values.URL,
              text: e.target.value,
            })
          }
          invalid={formik.errors.URL?.text}
        />
        <FormFeedback>
          {formik.errors?.URL?.text}
        </FormFeedback>
        <span className='input-charactor-count-template'>{formik.values.URL.text.length || 0}/25</span>
      </Col>
      <Col md={5} className="flex">
        <div className="full-width relative">
          <Input
            type="text"
            placeholder="Please add URL with https:// or http://"
            value={formik.values.URL.url}
            disabled={
              formik.values.buttons.indexOf("URL") === -1
            }
            onChange={(e) =>
              formik.setFieldValue("URL", {
                ...formik.values.URL,
                url: e.target.value,
              })
            }
            invalid={formik.errors.URL?.url}
          />
          <FormFeedback>{formik.errors?.URL?.url}</FormFeedback>
          <span className='input-charactor-count'>{formik.values.URL.url.length || 0}/2000</span>
        </div>
        {removeActionButton(item)}
      </Col >
    </> : action === 'QUICK_REPLY' && <Col md={9} className="d-flex">
      <div className="full-width relative">
        <Input
          type="text"
          placeholder="Enter text"
          value={formik.values.QUICK_REPLY.text}
          disabled={
            formik.values.buttons.indexOf("QUICK_REPLY") === -1
          }
          onChange={(e) =>
            formik.setFieldValue("QUICK_REPLY", {
              ...formik.values.QUICK_REPLY,
              text: e.target.value,
            })
          }
          invalid={formik.errors.QUICK_REPLY?.text}
        />
        <FormFeedback>
          {formik.errors?.QUICK_REPLY?.text}
        </FormFeedback>
        <span className='input-charactor-count'>{formik.values.QUICK_REPLY.text.length || 0}/250</span>
      </div>
      {removeActionButton(item)}
    </Col>
  }

  const removeActionButton = (item) => {
    return <Button
      className="action-icon-btn mt-2"
      disabled={Object.keys(selectedButtons).length === 1}
      onClick={() => {
        const newItems = { ...selectedButtons };
        delete newItems[item];

        const entries = Object.entries(newItems);
        const newObj = {};

        entries.forEach(([, value], index) => {
          newObj[index] = value;
        });
        setSelectedButtons(newObj);
        updateDropdownOption(newObj)
      }}
    >
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  }

  function sanitizeString(str) {
    return str.replace(/['"]/g, "");
  }

  function sanitizeSpace(input) {
    return input
      .replace(/[\n\r\t]/g, ' ')     // Replace newline (\n, \r) and tab (\t) with space
      .replace(/\s+/g, ' ')          // Replace multiple whitespace characters with single space
      .trim();                       // Remove leading/trailing spaces
  }

  const handleChange = (selected) => {
    if (selected !== null) {
      let text = `generate message using event ${selected?.eventTitle} which is conduct on ${selected?.eventDate} and ${selected?.eventSummery} with character limit of 1024`;
      handleAIContentCall(text);
    }
    setSelectedOption(selected);
  };

  const handleAIContentCall = (bodyText) => {
    const payload = {
      content: `${buttonText === 'Generate campaign content through AI'
        ? bodyText
        : 'Re-Generate below content ' + bodyText}
            Please format the output as a WhatsApp Business message:
          - Use short, clear paragraphs.
          - Insert a newline (\\n) after each paragraph.
          - No HTML tags.
          - If any links are included, show full URLs (https://example.com).
          - Keep tone professional and friendly.`
    };

    dispatch(Actions.RestaurantAdmin.SetLoading, true);

    API(API_REQUEST.post, GET_AICONTENT, payload)
      .then(res => {
        if (res.status === 200) {
          if (res.data.code === 200) {
            const cleanText = res.data.data;      // Unescape any double backslash newlines

            formik.setFieldValue("message", cleanText);
            setButtonText('Re-Generate campaign content through AI');
          } else {
            handleError('Something went wrong.');
          }
        } else {
          handleError('Something went wrong.');
        }
        dispatch(Actions.RestaurantAdmin.SetLoading, false);
      })
      .catch(err => {
        handleError(err);
        dispatch(Actions.RestaurantAdmin.SetLoading, false);
      });
  };

  const getTemplates = (fileType = 'text') => {
    dispatch(Actions.RestaurantAdmin.SetLoading, true)
    const params = {
      page: 1, 'size': 1000, isApproved: true
    }
    if (!fileType) fileType = 'text';
    params.templateType = fileType && fileType.includes('image') ? "image" : fileType.includes("pdf") ? "pdf" : fileType.includes("video") ? "video" : "text";

    // if(isRSVPChecked){
    //   params.templateType = 'rsvp'
    // }
    formik.setFieldValue("draftTemplateId", null)

    API(API_REQUEST.get, TEMPLATES_API, { params })
      .then(res => {
        const rowData = templatesListDTO(res?.data?.data?.rows)
        const templates = rowData?.map(template => ({ value: template.id, label: template.name }))
        setTemplates(templates)
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      })
      .catch(err => {
        handleError(err)
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      })
  }

  useEffect(() => {
    if (campaign) {
      getTemplates(campaign?.mediaType)
    } else {
      getTemplates('text')
    }
  }, [])

  //week days selection
  const weekDaysList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const convertToUTC = (timeStr, flag) => {
    const timeFormat = "HH:mm";
    const localTzStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let utcTime;
    if (flag) {
      const localTime = moment.tz(timeStr, timeFormat, 'UTC');
      utcTime = localTime.clone().tz(localTzStr);
    } else {
      const localTime = moment.tz(timeStr, timeFormat, localTzStr);
      utcTime = localTime.clone().tz('UTC');
    }
    return utcTime.format(timeFormat);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: campaign?.name || '',
      headerType: campaign?.headerType || "",
      message: campaign?.message || '',
      allCustomers: campaign?.customers?.length === customers?.length && campaign?.customers?.every(campaignCustomer =>
        customers.some(customer => customer.id === campaignCustomer.id)
      ),
      customers: !!campaign?.customers?.length ? campaign?.customers.map(customer => ({ label: customer?.name || '', value: customer?.id || '' })) : [],
      tags: !!campaign?.tags?.length ? campaign?.tags.map(tag => ({ label: tag?.tagName || '', value: tag?.id || '' })) : [],
      media: campaign?.media || '',
      occuranceStartDate: campaign?.occuranceStartDate && campaign?.occuranceStartDate !== "0000-00-00" ? campaign?.occurance === 'repeat' ? campaign?.occuranceStartDate : '' : '',
      occuranceEndDate: campaign?.occuranceEndDate && campaign?.occuranceEndDate !== "0000-00-00" ? campaign?.occurance === 'repeat' ? campaign?.occuranceEndDate : '' : '',
      occuranceDay: typeof campaign?.occuranceDay === 'string' ? campaign?.occuranceDay.split(',') : [],
      occuranceDate: campaign?.occuranceDate && campaign?.occuranceDate !== "0000-00-00" ? campaign?.occurance === 'donotrepeat' ? campaign?.occuranceDate : '' : '',
      occuranceTime: campaign?.occuranceTime ? convertToUTC(campaign?.occuranceTime, true) : '',
      isScheduled: campaign?.isScheduled || false,
      occurance: campaign?.occurance || '',
      draftTemplateId: campaign?.draftTemplateId != null ? templates.find(template => template.value == campaign?.draftTemplateId) : null,
      body: campaign?.body || "Hello, Greetings for the day, {{1}} Great day ahead.",
      footer: campaign?.footer || "Reply STOP to unsubscribe.",
      buttons: !!campaign?.buttons?.length
        ? campaign?.buttons.map((item) => item.type)
        : [],
      countryCode: setSelectedDropdownForSameValue(
        campaign?.buttons
          ?.find((item) => item.type === "PHONE_NUMBER")
          ?.phone_number?.slice(0, 2) || CountryCode.UK
      ),
      PHONE_NUMBER: {
        text:
          campaign?.buttons?.find((item) => item.type === "PHONE_NUMBER")
            ?.text || "",
        phone_number:
          campaign?.buttons
            ?.find((item) => item.type === "PHONE_NUMBER")
            ?.phone_number?.substring(2) || "",
      },
      URL: {
        text:
          campaign?.buttons?.find((item) => item.type === "URL")?.text || "",
        url: campaign?.buttons?.find((item) => item.type === "URL")?.url || "",
      },
      QUICK_REPLY: {
        text:
          campaign?.buttons?.find((item) => item.type === "QUICK_REPLY")
            ?.text || "",
      }
    },
    validationSchema: campaignValidationSchema,

    onSubmit: async (values) => {
      trimObjectValues(values, 'media')
      // values.message = values.message ? sanitizeSpace(values.message) : '';
      values.message = values.message;
      const filterData = removeEmptyKeysFromObject(values)
      
      if (filterData.media && !(typeof filterData.media === 'string' && ImageLinks.includes(filterData.media?.split(":")[0]))) {
        dispatch(Actions.RestaurantAdmin.SetLoading, true)
        const fileType = filterData?.media?.type?.split('/')[0];
        const logoResponse = await uploadImage(filterData.media, fileType === 'pdf' ? ImageType.CAMPAIGN_PDF : fileType === 'video' ? ImageType.CAMPAIGN_VIDEO : ImageType.CAMPAIGN_IMAGE).catch(err => {
          dispatch(Actions.RestaurantAdmin.SetLoading, false)
          handleError(err)
        })
        filterData.media = logoResponse.fileLink;
        filterData.mediaType = fileType === 'image' ? 'image' : fileType === 'video' ? 'video' : 'pdf';
      } else if (filterData.media && typeof filterData.media === 'string' && ImageLinks.includes(filterData.media?.split(":")[0])) {
        const filename = filterData.media.substring(filterData.media.lastIndexOf('/') + 1); // Get filename from URL
        const extension = filename.split('.').pop().toLowerCase(); // Get extension
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
        const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];
        filterData.mediaType = imageExtensions.includes(extension) ? 'image' : videoExtensions.includes(extension) ? 'video' : 'pdf';
      }
      filterData.tags = filterData?.tags?.length ? filterData.tags.map(tag => tag.value) : []
      filterData.customers = filterData?.customers?.length ? filterData.customers.map(customer => customer.value) : []
      if (!!formik.values.allCustomers) {
        filterData.customers = customers
        delete filterData.allCustomers
        await getCustomers().then(res => {
          filterData.customers = res?.length ? res.map(customer => customer.value) : []
        })
      }
      if (values.isScheduled && formik.values.occurance === 'donotrepeat') {
        filterData.occuranceStartDate = '';
        filterData.occuranceEndDate = '';
        filterData.occuranceDay = [];
        delete filterData.occuranceDay;
      } else {
        filterData.occuranceDate = "";
      }
      // if(isRSVPChecked){
      //   filterData.mediaType = 'rsvp';
      // }
      // filterData.isRsvp = isRSVPChecked ? false : false;
      filterData.occuranceTime = convertToUTC(values.occuranceTime);
      filterData.occuranceDay = weekDaysList.filter(day => values.occuranceDay.includes(day));
      
      filterData.isScheduled = values.isScheduled;
      
      const thirdWord = getThirdWord(values.message);
      if (thirdWord) {
        filterData.message = replaceThirdWordWithPlaceholder(values.message);
      }
      
      const quickReplyButtons = values.buttons.filter(button => button === "QUICK_REPLY");
      const otherButtons = values.buttons.filter(button => button !== "QUICK_REPLY");
      
      const buttons = [...otherButtons, ...quickReplyButtons].map((option) => ({
        type: option,
        ...values[option],
        ...(option === "PHONE_NUMBER" && {
          ...values[option],
          phone_number: `${values.countryCode?.value}${values[option].phone_number}`,
        }),
      }));
      const payload = {
        name: values.name,
        headerType: values.headerType,
        body: filterData.message,
        footer: values.footer,
        isRsvp: isRSVPChecked ? true : false,
        ...(buttonActions && { buttons: buttons }),
      };

      const campaignPayload = {
        name:filterData.name,
        media: filterData.media,
        mediaType: filterData.mediaType,
        tags: filterData.tags,
        customers: filterData.customers,
        occuranceStartDate: filterData.occuranceStartDate,
        occuranceEndDate: filterData.occuranceEndDate,
        occuranceDay: filterData.occuranceDay,
        occuranceDate: filterData.occuranceDate,
        isRsvp: filterData.isRsvp,
        occuranceTime: filterData.occuranceTime,
        isScheduled: filterData.isScheduled,
        message: thirdWord,
        draftTemplateId: null
      }

      console.log(campaignPayload)
      addQuickTemplate(payload).then(res => {    
        console.log(res.data)
        campaignPayload.draftTemplateId = res.data.data.id;   
        handleSuccess(campaignPayload);
      }).catch(err => {
        handleError(err)
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      });

            
    }
  });
  return (
    <Modal
      className="modal-dialog-centered edit-modal"
      isOpen={open}
      toggle={handleCloseModal}
      size='lg'
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Campaign
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleCloseModal}
        >
          <span aria-hidden={true}><FontAwesomeIcon icon={faXmark} size="sm" /></span>
        </button>
      </div>
      <div className="modal-body p-0 edit-template-body" >
        <Card className="border-0 edit-card">
          <CardBody>
            <Form role="form">
              <Row>
                <Col md={12}>
                  <InputField required placeholder="Name" fieldName="name" formik={formik} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label
                    for="exampleSelect"
                    className="inputfield required-field"
                  >
                    Header
                  </Label>
                  <FormGroup tag="fieldset" inline >
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="radio"
                          name="headerType"
                          value="DOCUMENT"
                          checked={formik.values.headerType === "DOCUMENT"}
                          onChange={formik.handleChange}
                        />
                        Document
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="radio"
                          name="headerType"
                          value="IMAGE"
                          checked={formik.values.headerType === "IMAGE"}
                          onChange={formik.handleChange}
                        />
                        Image
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="radio"
                          name="headerType"
                          value="TEXT"
                          checked={formik.values.headerType === "TEXT"}
                          onChange={formik.handleChange}
                        />
                        Text
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="radio"
                          name="headerType"
                          value="VIDEO"
                          checked={formik.values.headerType === "VIDEO"}
                          onChange={formik.handleChange}
                        />
                        Video
                      </Label>
                    </FormGroup>
                    {formik.touched?.headerType && formik.errors.headerType && (
                      <span className="error-message input-group-alternative">
                        {formik.errors.headerType}
                      </span>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputField placeholder="Media" fieldName="media" inputType="file" action={getTemplates} accept={CAMPAIGN_FILE_TYPE} formik={formik} />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label for="exampleSelect" className='inputfield'>
                    Tags
                  </Label>
                  <section className="mb-3 input-group-alternative">
                    <Select isMulti className="custom-select" options={tags} value={formik.values?.tags} isSearchable={false} styles={selectDropdownStyle}
                      onChange={selectedOption => {
                        formik.setFieldValue("tags", selectedOption);
                      }}
                    />
                    {formik.errors.tags && <span className="error-message input-group-alternative">{formik.errors.tags}</span>}
                  </section>
                </Col>
                <Col md={2} className='flex-center all-customers-checkbox'>
                  <FormGroup check inline className="custom-checkbox">
                    <Input type="checkbox" name='allCustomers' checked={formik.values.allCustomers} onChange={formik.handleChange} />
                  </FormGroup>
                  <Label className="inputfield mb-0">All Customers</Label>
                </Col>
                <Col md={6}>
                  <Label className='inputfield'>
                    Customers
                  </Label>
                  <section className="mb-3 input-group-alternative">
                    <Select isMulti isDisabled={formik.values.allCustomers} value={formik.values.customers} onInputChange={handleInputChange} styles={selectDropdownStyle}
                      onChange={selectedOption => formik.setFieldValue("customers", selectedOption)}
                      options={customers} className="custom-select" />
                    {!!formik.errors?.customers?.length && Array.isArray(formik.errors?.customers) ? <span className="error-message input-group-alternative">{formik.errors.customers.map((customer, index) => (`customer ${index + 1} ${customer?.value}`)).join(",")}</span>
                      : formik.errors.customers && <span className="error-message input-group-alternative">{formik.errors.customers}</span>}
                  </section>
                </Col>
              </Row>
              <Row>
                <Col md={2} className='d-flex align-items-center my-4'>
                  <FormGroup check inline className="custom-checkbox">
                    <Input
                      type="checkbox"
                      name="allCustomers"
                      checked={isRSVPChecked}
                      onChange={handleRSVPChange}
                    />
                  </FormGroup>
                  <Label className="inputfield mb-0">RSVP</Label>
                </Col>

                {isRSVPChecked && (
                  <Col md={4}>
                    <Label for="exampleSelect" className="inputfield">
                      Events
                    </Label>
                    <section className="mb-3 input-group-alternative">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Select an Event..."
                        value={selectedOption}
                        onChange={handleChange}
                        isClearable
                        isSearchable
                        name="eventName"
                        options={eventList}
                      />
                    </section>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={6} className='d-flex align-items-center my-4'>
                  <FormGroup check inline className="custom-checkbox">
                    <Input type="checkbox" name='isScheduled' checked={formik.values.isScheduled} onChange={formik.handleChange} />
                  </FormGroup>
                  <Label className="inputfield mb-0">Scheduled</Label>
                </Col>
                {formik.values.isScheduled && (
                  <Col md={6}>
                    <Label className="inputfield mb-0">Occurance<span className="required-field"></span></Label>
                    <div className="d-flex aling-items-center justify-content-evenly">
                      <FormGroup check className='mr-4'>
                        <Input
                          name="occurance"
                          type="radio"
                          value="donotrepeat"
                          checked={formik.values.occurance === 'donotrepeat'}
                          onChange={formik.handleChange}
                        />
                        {' '}
                        <Label check>
                          Do Not Repeat
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          name="occurance"
                          type="radio"
                          value="repeat"
                          checked={formik.values.occurance === 'repeat'}
                          onChange={formik.handleChange}
                        />
                        {' '}
                        <Label check>
                          Repeat
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                )}
              </Row>
              {formik.values.isScheduled && formik.values.occurance === 'repeat' && (
                <Row>
                  <Col>
                    <Label className='inputfield'>
                      Occurance Days<span className="required-field"></span>
                    </Label>
                    <div className='d-flex flex-wrap justify-content-between my-4'>
                      {weekDaysList.map(day => (
                        <div key={day} className="d-flex align-items-center justify-content-center ml-2">
                          <FormGroup check inline className="custom-checkbox pl-2">
                            <Input type="checkbox" name={day} checked={formik.values.occuranceDay.includes(day)} onChange={handleCheckboxChange} />
                          </FormGroup>
                          <Label className="inputfield mb-0">{day}</Label>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              )}
              {formik.values.isScheduled && formik.values.occurance === 'donotrepeat' && (
                <Row>
                  <Col md={5}>
                    <InputField placeholder="Scheduled Date" required fieldName="occuranceDate" inputType="date" formik={formik} />
                  </Col>
                  <Col md={2}>
                    <InputField placeholder="Time" required fieldName="occuranceTime" inputType="time" formik={formik} />
                  </Col>
                </Row>
              )}
              {formik.values.isScheduled && formik.values.occurance === 'repeat' && (
                <Row>
                  <Col md={5}>
                    <InputField placeholder="From" required fieldName="occuranceStartDate" inputType="date" formik={formik} />
                  </Col>
                  <Col md={5}>
                    <InputField placeholder="TO" required fieldName="occuranceEndDate" inputType="date" formik={formik} />
                  </Col>
                  <Col md={2}>
                    <InputField placeholder="Time" required fieldName="occuranceTime" inputType="time" formik={formik} />
                  </Col>
                </Row>
              )}
              {formik.values.isScheduled && (
                <Row>
                  <Col >
                    <Label className='inputfield'>
                      Template<span className="required-field"></span>
                    </Label>
                    <section className="mb-3 input-group-alternative">
                      <Select className="custom-select" value={formik.values.draftTemplateId} options={templates} isSearchable={false} styles={multiSelectDropdownStyle}
                        onChange={selectedOption => {
                          formik.setFieldValue("draftTemplateId", selectedOption);
                        }}
                      />
                    </section>
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <InputField
                    placeholder="Message"
                    fieldName="message"
                    inputType="textarea"
                    rows={5}
                    formik={formik}
                    showCharactorCount
                    maxLimit={1024}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputField
                    required
                    placeholder="Footer"
                    fieldName="footer"
                    formik={formik}
                    showCharactorCount
                    maxLimit={60}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label className='inputfield required-field'>
                    Buttons
                  </Label>
                  <section className="mb-4 input-group-alternative">
                    {TemplateButtonsDropdown.map(option => (
                      <div key={option.value} className="form-check">
                        <input
                          type="radio"
                          id={option.value}
                          name="buttonActions"
                          value={option.value}
                          checked={buttonActions === option.value}
                          onChange={() => setButtonActions(option.value)}
                          className="form-check-input"
                        />
                        <label htmlFor={option.value} className="form-check-label">
                          {option.label}
                        </label>
                      </div>
                    ))}
                  </section>
                </Col>
              </Row>
              {!!buttonActions && <>
                {Object.keys(selectedButtons).map((item) => {
                  return <Row key={item}>
                    <Col md={3}>
                      <section className="mb-4 input-group-alternative">
                        <Select className="custom-select"
                          options={buttonActionsOptions}
                          isSearchable={false}
                          value={buttonActionsOptions.find(option => option.value === selectedButtons[item]) || ''}
                          styles={multiSelectDropdownStyle}
                          onChange={selectedOption => {
                            updateDropdownOption({ ...selectedButtons, [item]: selectedOption?.value })
                            setSelectedButtons({ ...selectedButtons, [item]: selectedOption?.value })
                          }}
                          isOptionDisabled={(option) => option.disabled}
                        />
                      </section>
                    </Col>
                    {actionButtonOption(item, selectedButtons[item])}
                  </Row>
                })}
                {buttonActions !== 'rsvp_action' && (
                  <Button
                    color="primary"
                    type="button"
                    disabled={Object.keys(selectedButtons).length >= 3}
                    onClick={() => {
                      updateDropdownOption(selectedButtons)
                      setSelectedButtons({ ...selectedButtons, [Object.keys(selectedButtons).length]: '' })
                    }}
                  >
                    Add Another Button
                  </Button>)}
              </>}
            </Form>
          </CardBody>
        </Card>
        <div className="edit-view">
          <MobileViewCampaign template={formik.values} formik={formik} />
        </div>
      </div>
      <div className="modal-footer pt-2">
        <Button
          color='outline-primary'
          data-dismiss="modal"
          type="button"
          onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button color='primary' type="button" disabled={!!Object.values(formik.errors)?.length} onClick={formik.handleSubmit}>
          Submit
        </Button>
      </div>
    </Modal>
  )
}